// Forebrew theme JS
(function () {
  function swapMainImage(img, newSrc) {
    if (img.dataset.swapping === '1') return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (img.getAttribute('src') === newSrc) return;
    img.dataset.swapping = '1';
    const preload = new Image();
    let loaded = false;
    preload.onload = preload.onerror = () => { loaded = true; };
    preload.src = newSrc;
    requestAnimationFrame(() => {
      img.classList.add('is-swapping');
      const swap = () => {
        img.setAttribute('src', newSrc);
        const onShown = () => {
          img.classList.remove('is-swapping');
          img.dataset.swapping = '';
        };
        if (img.complete) requestAnimationFrame(() => requestAnimationFrame(onShown));
        else img.addEventListener('load', onShown, { once: true });
      };
      const wait = () => {
        if (loaded) setTimeout(swap, 280);
        else setTimeout(wait, 30);
      };
      wait();
    });
  }

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Accordions
  document.addEventListener('click', (e) => {
    const q = e.target.closest('.accord-q');
    if (!q) return;
    const item = q.closest('.accord-item');
    if (!item) return;
    const isOpen = item.classList.contains('open');
    if (item.parentElement) {
      item.parentElement.querySelectorAll('.accord-item.open').forEach((sib) => { if (sib !== item) sib.classList.remove('open'); });
    }
    item.classList.toggle('open', !isOpen);
  });

  // Ritual mobile carousel — mark centered step as active
  document.querySelectorAll('.ritual__grid').forEach((track) => {
    const steps = Array.from(track.querySelectorAll('.ritual-step'));
    if (steps.length === 0) return;
    const setActive = () => {
      if (window.matchMedia('(min-width: 881px)').matches) {
        steps.forEach((s) => s.classList.remove('is-active'));
        return;
      }
      const trackRect = track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let best = null, bestDist = Infinity;
      steps.forEach((s) => {
        const r = s.getBoundingClientRect();
        const c = r.left + r.width / 2;
        const d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = s; }
      });
      steps.forEach((s) => s.classList.toggle('is-active', s === best));
    };
    setActive();
    track.addEventListener('scroll', () => requestAnimationFrame(setActive), { passive: true });
    window.addEventListener('resize', setActive);
  });

  // Product gallery touch swipe (mobile)
  document.querySelectorAll('.product__main-img').forEach((box) => {
    let startX = 0, startY = 0, tracking = false;
    box.addEventListener('touchstart', (e) => {
      const t = e.touches[0]; startX = t.clientX; startY = t.clientY; tracking = true;
    }, { passive: true });
    box.addEventListener('touchend', (e) => {
      if (!tracking) return; tracking = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const sel = dx < 0 ? '[data-gallery-next]' : '[data-gallery-prev]';
      box.querySelector(sel)?.click();
    }, { passive: true });
  });

  // Product gallery thumbs
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.product__thumb');
    if (!thumb) return;
    const gallery = thumb.closest('.product__gallery');
    if (!gallery) return;
    const main = gallery.querySelector('.product__main-img img');
    const src = thumb.getAttribute('data-fullimg') || thumb.querySelector('img')?.getAttribute('src');
    if (main && src) { swapMainImage(main, src); }
    const allThumbs = Array.from(gallery.querySelectorAll('.product__thumb'));
    allThumbs.forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    const track = gallery.querySelector('[data-thumbs-track]');
    if (track) {
      const idx = allThumbs.indexOf(thumb);
      const target = allThumbs[idx + 1] || thumb;
      const tRect = track.getBoundingClientRect();
      const eRect = target.getBoundingClientRect();
      if (eRect.right > tRect.right - 2 || eRect.left < tRect.left + 2) {
        track.scrollBy({ left: eRect.right - tRect.right + 12, behavior: 'smooth' });
      }
    }
  });

  // Infinite horizontal slider — clones content + debounced wraparound
  document.querySelectorAll('[data-slider-track]').forEach((track) => {
    const items = Array.from(track.children);
    if (items.length === 0) return;
    const gap = 28;
    items.forEach((c) => track.insertBefore(c.cloneNode(true), track.firstChild));
    items.forEach((c) => track.appendChild(c.cloneNode(true)));
    const measure = () => {
      const w = items[0]?.getBoundingClientRect().width || 0;
      return { stepWidth: w + gap, setWidth: (w + gap) * items.length };
    };
    const center = () => {
      const { setWidth } = measure();
      track.scrollLeft = setWidth;
    };
    requestAnimationFrame(center);
    window.addEventListener('resize', center);
    let timer;
    track.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const { setWidth } = measure();
        if (track.scrollLeft < setWidth * 0.5) {
          const offset = track.scrollLeft;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = setWidth + offset;
          track.style.scrollBehavior = '';
        } else if (track.scrollLeft > setWidth * 1.5) {
          const offset = track.scrollLeft - setWidth * 2;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = setWidth + offset;
          track.style.scrollBehavior = '';
        }
      }, 120);
    }, { passive: true });
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-slider-prev], [data-slider-next]');
    if (!btn) return;
    const slider = btn.closest('[data-slider]');
    const track = slider?.querySelector('[data-slider-track]');
    if (!track) return;
    const card = track.querySelector(':scope > *');
    const step = card ? card.getBoundingClientRect().width + 28 : track.clientWidth * 0.8;
    track.scrollBy({ left: btn.matches('[data-slider-next]') ? step : -step, behavior: 'smooth' });
  });

  // Product gallery prev/next
  document.addEventListener('click', (e) => {
    const navBtn = e.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (!navBtn) return;
    e.preventDefault();
    const gallery = navBtn.closest('.product__gallery');
    if (!gallery) return;
    const thumbs = Array.from(gallery.querySelectorAll('.product__thumb'));
    if (thumbs.length < 2) return;
    const activeIdx = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
    const dir = navBtn.matches('[data-gallery-next]') ? 1 : -1;
    const nextIdx = (activeIdx + dir + thumbs.length) % thumbs.length;
    const main = gallery.querySelector('.product__main-img img');
    const fullSrc = thumbs[nextIdx].getAttribute('data-fullimg') || thumbs[nextIdx].querySelector('img')?.getAttribute('src');
    if (main && fullSrc) { swapMainImage(main, fullSrc); }
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === nextIdx));
    const track = gallery.querySelector('[data-thumbs-track]');
    if (track) {
      const target = thumbs[Math.min(nextIdx + (dir > 0 ? 1 : 0), thumbs.length - 1)];
      const tRect = track.getBoundingClientRect();
      const eRect = target.getBoundingClientRect();
      if (eRect.right > tRect.right - 2) {
        track.scrollBy({ left: eRect.right - tRect.right + 12, behavior: 'smooth' });
      } else if (eRect.left < tRect.left + 2) {
        track.scrollBy({ left: eRect.left - tRect.left - 12, behavior: 'smooth' });
      }
    }
  });

  // Auto-highlight the per-day price in bundle subtitles (robust against missing markup)
  document.querySelectorAll('.product__bundle-sub').forEach((el) => {
    if (el.querySelector('.perday')) return; // already highlighted
    const html = el.innerHTML;
    const replaced = html.replace(/(~?\s*\$\s*\d[\d.,]*\s*\/\s*day)/i, '<span class="perday">$1</span>');
    if (replaced !== html) el.innerHTML = replaced;
  });

  // Variant picker (radio-style cards) — syncs across all product forms (incl. sticky bar)
  document.addEventListener('click', (e) => {
    const v = e.target.closest('.product__variant');
    if (!v) return;
    if (v.tagName === 'BUTTON') e.preventDefault();
    const id = v.dataset.variantId;
    const qty = v.dataset.quantity;
    const priceFmt = v.dataset.priceFormatted;
    const compareFmt = v.dataset.compareFormatted;
    const note = v.dataset.note;
    const activeLbl = v.dataset.activeLabel;
    document.querySelectorAll('.product__variant').forEach((x) => {
      x.classList.toggle('is-active', x.dataset.variantId === id && x.dataset.quantity === qty);
    });
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput && id) idInput.value = id;
      const qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput && qty) qtyInput.value = qty;
      const btnEl = form.querySelector('[data-add-label]');
      if (btnEl && priceFmt) {
        const priceEl = btnEl.querySelector('[data-add-price]');
        if (priceEl) {
          priceEl.textContent = '— ' + priceFmt;
        } else {
          const labelMatch = btnEl.textContent.match(/^(.+?)\s+—/);
          const label = labelMatch ? labelMatch[1] : 'Add to Cart';
          btnEl.textContent = label + ' — ' + priceFmt;
        }
      }
    });
    document.querySelectorAll('[data-price-main]').forEach((el) => {
      if (!priceFmt) return;
      if (compareFmt) {
        el.innerHTML = '<s class="product__price-was">' + compareFmt + '</s> <span class="product__price-now">' + priceFmt + '</span>';
      } else {
        el.textContent = priceFmt;
      }
    });
    const savedFmt = v.dataset.savedFormatted;
    document.querySelectorAll('[data-price-badge]').forEach((el) => {
      if (savedFmt) { el.textContent = 'Save ' + savedFmt; el.hidden = false; }
      else { el.hidden = true; }
    });
    document.querySelectorAll('.product__price-note').forEach((el) => { if (note) el.textContent = note; });
    document.querySelectorAll('[data-variant-active]').forEach((el) => { if (activeLbl) el.textContent = activeLbl; });
  });

  // Sticky add-to-cart visibility — show only after user scrolls well past main buy button
  const stickyBar = document.querySelector('[data-sticky-cart]');
  const mainBuyBtn = document.querySelector('.product__buy');
  if (stickyBar && mainBuyBtn) {
    const onScroll = () => {
      const rect = mainBuyBtn.getBoundingClientRect();
      const scrolledPast = rect.bottom < -300;
      stickyBar.classList.toggle('is-visible', scrolledPast);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Cart drawer
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  const openCart = () => { drawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.documentElement.classList.add('cart-open'); document.body.classList.add('cart-open'); };
  const closeCart = () => { drawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.documentElement.classList.remove('cart-open'); document.body.classList.remove('cart-open'); };
  document.querySelectorAll('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  document.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  const showToast = (msg) => {
    let t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    setTimeout(() => t.classList.remove('is-visible'), 1800);
  };

  // Free gift with purchase — auto-add the free pouch whenever a qualifying item is in the cart
  const FREE_GIFT_VARIANT = 56026153484628;
  const FREE_GIFT_HANDLE = 'soap-saver-pouch';
  let giftSyncing = false;
  const isGift = (item) => item.handle === FREE_GIFT_HANDLE || item.variant_id === FREE_GIFT_VARIANT;
  const syncFreeGift = async (cart) => {
    if (giftSyncing) return false;
    const hasQualifying = cart.items.some((i) => !isGift(i));
    const gift = cart.items.find(isGift);
    try {
      giftSyncing = true;
      if (hasQualifying && !gift) {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: FREE_GIFT_VARIANT, quantity: 1 }) });
        return true;
      }
      if (!hasQualifying && gift) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: gift.key, quantity: 0 }) });
        return true;
      }
      if (gift && gift.quantity > 1) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: gift.key, quantity: 1 }) });
        return true;
      }
    } catch (e) { console.error('Free gift sync failed', e); }
    finally { giftSyncing = false; }
    return false;
  };

  const refreshCart = async () => {
    let cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
    if (await syncFreeGift(cart)) {
      cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
    }
    const countEl = document.querySelector('.cart-button__count');
    const btn = document.querySelector('.cart-button');
    if (countEl) { countEl.textContent = cart.item_count; countEl.toggleAttribute('hidden', cart.item_count === 0); }
    const titleCountEl = document.querySelector('[data-cart-title-count]');
    if (titleCountEl) titleCountEl.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
    if (btn) { btn.classList.add('bumped'); setTimeout(() => btn.classList.remove('bumped'), 300); }

    const body = document.querySelector('.cart-drawer__body');
    const subEl = document.querySelector('.cart-drawer__subtotal-value');
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
    const saveRow = document.querySelector('.cart-drawer__savings');
    if (saveRow) {
      const origTotal = cart.items.reduce((sum, i) => sum + i.original_line_price, 0);
      const savings = origTotal - cart.total_price;
      const saveVal = saveRow.querySelector('.cart-drawer__savings-value');
      if (savings > 0) { saveRow.hidden = false; if (saveVal) saveVal.textContent = '−' + formatMoney(savings); }
      else { saveRow.hidden = true; }
    }

    // Savings row — sum of line discounts (incl. BOGO free items)
    const origTotal = cart.items.reduce((sum, item) => sum + item.original_line_price, 0);
    const savings = origTotal - cart.total_price;
    const foot = document.querySelector('.cart-drawer__foot');
    let savingsEl = document.querySelector('.cart-drawer__savings');
    if (savings > 0 && foot) {
      if (!savingsEl) {
        savingsEl = document.createElement('div');
        savingsEl.className = 'cart-drawer__savings';
        savingsEl.innerHTML = '<span>You save</span><span class="cart-drawer__savings-value"></span>';
        foot.insertBefore(savingsEl, foot.querySelector('.cart-drawer__subtotal'));
      }
      savingsEl.querySelector('.cart-drawer__savings-value').textContent = '−' + formatMoney(savings);
    } else if (savingsEl) {
      savingsEl.remove();
    }

    const drawerEl = document.querySelector('.cart-drawer');
    if (drawerEl) drawerEl.classList.toggle('is-empty', cart.item_count === 0);
    if (!body) return;
    if (cart.item_count === 0) {
      const stash = document.querySelector('[data-cart-empty-template]');
      body.innerHTML = stash ? stash.innerHTML : '<div class="cart-drawer__empty"><p>Your cart is quiet.</p></div>';
      return;
    } else {
      const orderedItems = cart.items.slice().sort((a, b) => (isGift(a) ? 1 : 0) - (isGift(b) ? 1 : 0));
      body.innerHTML = orderedItems.map(item => {
        const gift = isGift(item);
        return `
        <div class="cart-line${gift ? ' cart-line--gift' : ''}" data-key="${item.key}">
          <div class="cart-line__img">${item.handle === 'nona-premium-persimmon-soap' ? `<img src="https://cdn.shopify.com/s/files/1/0984/5987/7716/files/Skin_1.webp?v=1780567107&width=200" alt="">` : (item.image ? `<img src="${item.image}" alt="">` : '')}</div>
          <div>
            <div class="cart-line__name">${item.product_title}${gift ? ' <span class="cart-line__gift-tag">Free gift</span>' : ''}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
            ${gift ? '' : `<div class="cart-line__qty">
              <button data-qty-change="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button data-qty-change="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>`}
          </div>
          <div class="cart-line__price">
            ${item.final_line_price === 0 ? `<span class="cart-line__free">${item.original_line_price > 0 ? `<s class="cart-line__was">${formatMoney(item.original_line_price)}</s> ` : ``}FREE</span>` : `<span>${formatMoney(item.final_line_price)}</span>`}
            ${gift ? '' : `<button class="cart-line__remove" type="button" data-qty-change="${item.key}" data-qty="0" aria-label="Remove">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 13a2 2 0 002 2h8a2 2 0 002-2l1-13M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/></svg>
            </button>`}
          </div>
        </div>
      `;
      }).join('');
    }
  };

  const formatMoney = (cents) => {
    const fmt = (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100); }
    catch { return '$' + (cents / 100).toFixed(2); }
  };

  // qty change in drawer
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    const key = b.dataset.qtyChange;
    const qty = Math.max(0, parseInt(b.dataset.qty, 10));
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    refreshCart();
  });

  // Add to cart form intercept
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const originalLabel = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    try {
      const data = new FormData(form);
      if (!data.get('quantity')) data.append('quantity', '1');
      const res = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const json = await res.json();
      if (!res.ok) {
        showToast(json.description || json.message || 'Could not add to cart');
        return;
      }
      await refreshCart();
      openCart();
    } catch (err) {
      console.error('Add to cart error', err);
      showToast('Network error — try again');
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = originalLabel; }
    }
  });

  // initial cart state
  refreshCart();
})();

/* Video testimonial slider — global init (section + inline product-info reel) */
(function(){
  function initVT(root){
    var track = root.querySelector('[data-vt-track]');
    if(!track || root.dataset.vtInit) return;
    root.dataset.vtInit = '1';
    var prev = root.querySelector('[data-vt-prev]');
    var next = root.querySelector('[data-vt-next]');
    function step(dir){ var card = track.querySelector('.vid-testi__card'); var amt = card ? card.getBoundingClientRect().width + 18 : 260; track.scrollBy({left: dir*amt, behavior:'smooth'}); }
    if(prev) prev.addEventListener('click', function(){step(-1);});
    if(next) next.addEventListener('click', function(){step(1);});
    root.querySelectorAll('.vid-testi__card').forEach(function(card){
      var video = card.querySelector('[data-vt-video]'); if(!video) return;
      var big = card.querySelector('[data-vt-play]');
      var ctrl = card.querySelector('[data-vt-ctrl]');
      var toggleBtn = card.querySelector('[data-vt-toggle]');
      var muteBtn = card.querySelector('[data-vt-mute]');
      var bar = card.querySelector('[data-vt-progress]');
      var fill = card.querySelector('[data-vt-fill]');
      var vol = card.querySelector('[data-vt-vol]');
      function syncMuteUI(){ if(ctrl) ctrl.classList.toggle('is-muted', video.muted || video.volume===0); if(vol) vol.value = video.muted ? 0 : video.volume; }
      function play(){ root.querySelectorAll('[data-vt-video]').forEach(function(v){ if(v!==video) v.pause(); }); video.muted=false; var p=video.play(); if(p&&p.catch) p.catch(function(){ video.muted=true; video.play(); }); syncMuteUI(); }
      if(big) big.addEventListener('click', play);
      if(toggleBtn) toggleBtn.addEventListener('click', function(e){ e.stopPropagation(); if(video.paused) play(); else video.pause(); });
      if(muteBtn) muteBtn.addEventListener('click', function(e){ e.stopPropagation(); video.muted=!video.muted; if(!video.muted && video.volume===0) video.volume=1; syncMuteUI(); });
      if(vol) vol.addEventListener('input', function(){ var val=parseFloat(vol.value); video.volume=val; video.muted=(val===0); syncMuteUI(); });
      if(bar) bar.addEventListener('click', function(e){ var r=bar.getBoundingClientRect(); if(video.duration) video.currentTime=((e.clientX-r.left)/r.width)*video.duration; });
      video.addEventListener('play', function(){ card.classList.add('is-active','is-playing'); });
      video.addEventListener('pause', function(){ card.classList.remove('is-playing'); });
      video.addEventListener('timeupdate', function(){ if(fill && video.duration) fill.style.width=(video.currentTime/video.duration*100)+'%'; });
      video.addEventListener('ended', function(){ card.classList.remove('is-active','is-playing'); video.currentTime=0; if(fill) fill.style.width='0%'; });
    });
  }
  function run(){ document.querySelectorAll('[data-vid-testi]').forEach(initVT); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
